import queryString from 'query-string'
import { partialRight } from 'lodash'
import { encodeQueryData } from './encode-query-params'

const playlistUrl = ({ pk = '' } = {}) => `/playlists/${pk.split('#')[1]}`

const contentUrl = (item, from, position = null, extraParams = {}) => {
  let baseUrl
  if (item.type === 'playlist') {
    baseUrl = playlistUrl(item)
  } else if (item.type === 'external') {
    return item.url
  } else if (item?.primaryType?.includes('skill-bite') || item?.skillBiteId) {
    baseUrl = `/skill-bites/${item.skillBiteId}`
  } else {
    baseUrl = item.staticUrl
      ? `/${item.locationId}/${item.staticUrl}`
      : `/${item.locationId}/${item.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`
  }

  const data = {
    ...(from && { from }),
    ...(position !== null && { position }),
    ...extraParams
  }
  const queryData = encodeQueryData(data)
  return `${baseUrl}${queryData.length ? `?${queryData}` : ''}`
}

// Always use the same separator
const qsArgs = { arrayFormat: 'comma' }

const qsParse = partialRight(queryString.parse, qsArgs)
const qsStringify = partialRight(queryString.stringify, qsArgs)

const categoryUrl = (category, pathToRoot) => {
  const pathArr = categoryPath(category, pathToRoot)
  const pathForUrl = pathArr.length > 1 ? pathArr.slice(0, -1) : pathArr
  const pathname = pathForUrl
    .reverse()
    .map(({ staticUrl }) => staticUrl)
    .join('/')

  return `/${category.sk}/${pathname}`
}

/**
 * Not every crumb in a trail is a real category. The playlist context
 * (hooks/usePlaylistNavigation) synthesises crumbs to sit above a piece of
 * content, and one of them is a plain destination with no category behind it —
 * no `staticUrl`, so the `/sk/staticUrl` shape rendered it as `/1/undefined`.
 * Such a crumb carries its own `url` and is used verbatim.
 */
const getCategoryPathForBreadcrumb = (category) => {
  if (category.url) return category.url

  return `/${category.sk}/${category.staticUrl}`
}

const categoryPath = (category, pathToRoot) => {
  const posInPath = pathToRoot.findIndex(({ sk }) => sk === category.sk)

  return posInPath > -1
    ? pathToRoot.slice(posInPath)
    : [category, ...pathToRoot]
}

const assessmentUrl = (assessmentId) => `/assessments/${assessmentId}/`
const authorUrl = (authorSlug) => `/authors/${authorSlug}`

export {
  contentUrl,
  authorUrl,
  playlistUrl,
  categoryUrl,
  getCategoryPathForBreadcrumb,
  categoryPath,
  qsParse,
  qsStringify,
  assessmentUrl
}
